<template>
  <el-card
    class="card-container"
    shadow="never"
  >
    <el-row
      slot="header"
      type="flex"
      justify="space-between"
      align="middle"
    >
      <h1 class="card-container__title">Nghiệp vụ khác ({{ data.length }})</h1>
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="handleCreate"
      >
        Thêm mới
      </el-button>
    </el-row>
    <el-table
      header-row-class-name="table-header"
      :data="data"
      size="small"
    >
      <el-table-column
        v-for="(c, index) in columns"
        :key="index"
        :prop="c.key"
        :label="c.label"
        :align="c.align"
        :width="c.width"
        :min-width="c.min_width"
      >
        <template slot-scope="scope">
          <span v-if="c.key === 'fields'">
            {{ fields.filter((f) => scope.row.fields.includes(f.key)).map((f) => f.name).join(', ') }}
          </span>
          <span v-else>
            {{ scope.row[c.key] }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="Thao tác"
        width="100"
        fixed="right"
        align="center"
      >
        <template slot-scope="scope">
          <Buttons
            :item="scope.row"
            :buttons="['edit', 'delete']"
            @edit="(v) => handleUpdate(v)"
            @delete="(v) => handleDelete(v)"
          />
        </template>
      </el-table-column>
    </el-table>
    <ActionFormPopup
      v-if="formVisible"
      :visible="formVisible"
      :item="selectedItem"
      :fields="fields"
      :actions="data"
      @close="formVisible = false"
      @save="handleSave"
    />
  </el-card>
</template>

<script>
import ActionFormPopup from "../../popups/ActionForm.vue";
import Buttons from "@/components/items/Buttons.vue";
import { notification } from "@/utils/common";

export default {
  name: "ConfigObjectActions",
  components: {
    ActionFormPopup,
    Buttons,
  },
  props: {
    object: Object,
  },
  data() {
    return {
      selectedItem: null,
      formVisible: false,
    };
  },
  computed: {
    data() {
      return (this.object?.extra?.actions || []).sort(
        (a, b) => a.order - b.order
      );
    },
    fields() {
      const data = this.object?.extra?.fields || [];
      return data;
    },
    columns() {
      return [
        {
          label: "STT",
          key: "order",
          width: 50,
        },
        {
          label: "Mã",
          key: "key",
        },
        {
          label: "Tên nghiệp vụ",
          key: "name",
        },
        {
          label: "Các trường dữ liệu",
          key: "fields",
        },
        {
          label: "Mô tả nghiệp vụ",
          key: "description",
        },
      ];
    },
  },
  methods: {
    handleCreate() {
      this.selectedItem = null;
      this.formVisible = true;
    },
    handleUpdate(item) {
      this.selectedItem = item;
      this.formVisible = true;
    },
    handleDelete(item) {
      this.$confirm(`Bạn có chắc chắn muốn xoá không?`, "Xác nhận", {
        confirmButtonText: "Xoá",
        cancelButtonText: "Huỷ",
        type: "warning",
      }).then(() => {
        const actions = this.data.filter((g) => g.key !== item.key);
        this.handleSave({
          payload: { actions },
          success: () => {
            notification(this, "success", "delete", `nhóm hiển thị`);
          },
          error: () => {
            notification(this, "error", "delete", "nhóm hiển thị");
          },
        });
      });
    },
    handleSave(data = { payload: {}, success: () => {}, error: () => {} }) {
      this.$emit("save", {
        payload: data.payload,
        success: data.success,
        error: data.error,
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
